import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'videoUrlDecode'
})
export class VideoUrlDecodePipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(videoUrl: string, autoplay: boolean = false, loop: boolean = false): SafeResourceUrl | null {
    if (!videoUrl) return null;
    
    const embedUrl = this.getEmbedUrl(videoUrl, autoplay, loop);
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  private getEmbedUrl(videoUrl: string, autoplay: boolean, loop: boolean): string {
    // YouTube
    if (this.isYouTubeUrl(videoUrl)) {
      const videoId = this.extractYouTubeId(videoUrl);
      if (!videoId) return videoUrl;
      
      let embedUrl = `https://www.youtube.com/embed/${videoId}`;
      const params = this.buildYouTubeParams(autoplay, loop, videoId);
      if (params) {
        embedUrl += `?${params}`;
      }
      return embedUrl;
    }
    
    // Vimeo
    if (this.isVimeoUrl(videoUrl)) {
      const videoId = this.extractVimeoId(videoUrl);
      if (!videoId) return videoUrl;
      
      let embedUrl = `https://player.vimeo.com/video/${videoId}`;
      const params = this.buildVimeoParams(autoplay, loop);
      if (params) {
        embedUrl += `?${params}`;
      }
      return embedUrl;
    }
    
    return videoUrl;
  }

  private isYouTubeUrl(url: string): boolean {
    return url.includes('youtube.com') || url.includes('youtu.be');
  }

  private isVimeoUrl(url: string): boolean {
    return url.includes('vimeo.com');
  }

  private extractYouTubeId(url: string): string {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  }

  private extractVimeoId(url: string): string {
    const regExp = /vimeo\.com\/([0-9]+)/;
    const match = url.match(regExp);
    return match ? match[1] : '';
  }

  private buildYouTubeParams(autoplay: boolean, loop: boolean, videoId: string): string {
    const params: string[] = [];
    params.push('controls=0');
    params.push('playsinline=1');
    params.push('mute=1');
    
    if (autoplay) {
      params.push('autoplay=1');
    }
    
    if (loop) {
      params.push('loop=1');
      params.push(`playlist=${videoId}`);
    }
    
    return params.join('&');
  }

  private buildVimeoParams(autoplay: boolean, loop: boolean): string {
    const params: string[] = [];
    params.push('mute=1');
    
    if (autoplay) {
      params.push('autoplay=1');
    }
    
    if (loop) {
      params.push('loop=1');
    }
    
    return params.join('&');
  }
}
